import _regeneratorRuntime from "@babel/runtime/helpers/esm/regeneratorRuntime";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import { routesArraySelector, sendGlobalMessage, useAppStore } from "../../store";
import { Breadcrumb, theme } from "antd";
import { memo, useEffect, useState } from "react";
import { generatePath, matchRoutes, useLocation, useNavigate } from "react-router-dom";
import { getGlobalShareConfigValueByKey } from "../../utils/globalShareConfig";
import { jsx as _jsx } from "react/jsx-runtime";
// 最定义修改面包屑接收全局事件
function getChangedBreadcrumb(_x) {
  return _getChangedBreadcrumb.apply(this, arguments);
}
function _getChangedBreadcrumb() {
  _getChangedBreadcrumb = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(data) {
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          return _context2.abrupt("return", new Promise(function (resolve, reject) {
            sendGlobalMessage({
              "@@globalBreadcrumbItems": data
            }, {
              callback: function callback(callbackData) {
                if (!callbackData) {
                  resolve(data);
                }
                if (callbackData instanceof Array && callbackData[0]) {
                  resolve(callbackData[0]["@@changedBreadcrumbItems"]);
                }
                reject();
              }
            });
          }));
        case 1:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _getChangedBreadcrumb.apply(this, arguments);
}
var ItemRender = function ItemRender(currentRoute, params, items) {
  var _items;
  var layoutBasePath = useAppStore.getState().layoutBasePath;
  var $currentRoute = currentRoute;
  if (!$currentRoute) {
    return null;
  }
  var isSplitMenu = getGlobalShareConfigValueByKey("splitMenus") || false;
  var isLast = ($currentRoute === null || $currentRoute === void 0 ? void 0 : $currentRoute.path) === ((_items = items[items.length - 1]) === null || _items === void 0 ? void 0 : _items.path);
  //TODO 暂且用斜杠方式判断splitMenus情景下是否为第一个菜单
  var isFirst = isSplitMenu && (($currentRoute === null || $currentRoute === void 0 ? void 0 : $currentRoute.parentPath) || "").split("/").length === 2 || !$currentRoute.parentPath || $currentRoute.parentPath === layoutBasePath;
  var hasChild = $currentRoute === null || $currentRoute === void 0 ? void 0 : $currentRoute.hasChild;
  var isAllImplicit = $currentRoute === null || $currentRoute === void 0 ? void 0 : $currentRoute.isAllImplicit;
  // 第一个菜单，并且有子菜单，无需点击
  if (isFirst && hasChild && !isAllImplicit) {
    return /*#__PURE__*/_jsx("span", {
      children: $currentRoute.title
    });
  }
  return isLast || $currentRoute.menuGroup ? /*#__PURE__*/_jsx("span", {
    children: $currentRoute.title
  }) : /*#__PURE__*/_jsx("a", {
    href: $currentRoute.path,
    onClick: function onClick(e) {
      var _$currentRoute$onClic;
      e.preventDefault();
      (_$currentRoute$onClic = $currentRoute.onClick) === null || _$currentRoute$onClic === void 0 || _$currentRoute$onClic.call($currentRoute, e);
    },
    children: $currentRoute.title
  });
};
var GlobalBreadcrumb = /*#__PURE__*/memo(function () {
  var _useLocation = useLocation(),
    pathname = _useLocation.pathname;
  var navigate = useNavigate();
  var layoutBasePath = useAppStore(function (s) {
    return s.layoutBasePath;
  });
  var flatPathRoutes = useAppStore(function (s) {
    return s.flatPathRoutes;
  });
  var globalBreadcrumb = useAppStore(function (s) {
    return s.globalBreadcrumb;
  });
  var routesPaths = useAppStore(routesArraySelector);
  var _ref = matchRoutes(routesPaths, pathname) || [],
    _ref2 = _slicedToArray(_ref, 1),
    matchRoute = _ref2[0];
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    items = _useState2[0],
    setItems = _useState2[1];
  var token = theme.useToken().token;
  var initItems = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var currentRoute, list, getItems, result;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            getItems = function _getItems(route) {
              if (!route) {
                return;
              }
              list.unshift(_objectSpread(_objectSpread({}, route), {}, {
                title: route.name,
                path: route.path,
                onClick: function onClick() {
                  var pathWithParams = generatePath(route.path, matchRoute.params || {});
                  navigate(pathWithParams || route.path);
                }
              }));
              if (route.parentPath && route.parentPath !== layoutBasePath) {
                getItems(flatPathRoutes[route.parentPath]);
              }
            };
            if (matchRoute) {
              _context.next = 3;
              break;
            }
            return _context.abrupt("return");
          case 3:
            currentRoute = flatPathRoutes[matchRoute.route.path];
            list = [];
            getItems(currentRoute);
            _context.next = 8;
            return getChangedBreadcrumb(list.filter(function (el) {
              return !el.hideInBreadcrumb;
            }));
          case 8:
            result = _context.sent;
            setItems(result);
          case 10:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function initItems() {
      return _ref3.apply(this, arguments);
    };
  }();
  useEffect(function () {
    initItems();
  }, [pathname, flatPathRoutes]);
  return items.length === 1 ? null : /*#__PURE__*/_jsx(Breadcrumb, _objectSpread({
    params: (matchRoute === null || matchRoute === void 0 ? void 0 : matchRoute.params) || {},
    style: {
      paddingBlockEnd: token.paddingXS
    },
    itemRender: ItemRender,
    items: items
  }, globalBreadcrumb));
});
export default GlobalBreadcrumb;